import type { User } from "@/services/api/users";
import {
  sortBy,
  comparators,
  type SortDirection,
} from "@/shared/lib/sortUtils";

export type SortField =
  | "email"
  | "registered"
  | "createdDate"
  | "lastUpdated"
  | "role";

export type { SortDirection };

export function sortUsers(
  users: User[],
  sortField: SortField,
  sortDirection: SortDirection
): User[] {
  return sortBy(users, sortField, sortDirection, {
    email: comparators.string((user: User) => user.email),
    registered: comparators.date((user: User) => user.lastLoginAt ?? null),
    createdDate: comparators.date((user: User) => user.createdDate ?? null),
    lastUpdated: comparators.date((user: User) => user.lastLoginAt ?? null),
    role: comparators.string((user: User) => user.role ?? null),
  });
}
